import { render, staticRenderFns } from "./ConfigViewDialog.vue?vue&type=template&id=dafd59da"
import script from "./ConfigViewDialog.vue?vue&type=script&lang=js"
export * from "./ConfigViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports